import { render, staticRenderFns } from "./junminFooter.vue?vue&type=template&id=f692b960&scoped=true"
import script from "./junminFooter.vue?vue&type=script&lang=js"
export * from "./junminFooter.vue?vue&type=script&lang=js"
import style0 from "./junminFooter.vue?vue&type=style&index=0&id=f692b960&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f692b960",
  null
  
)

export default component.exports